import { MessagesIcon } from 'assets/icons';
import React from 'react';

export function EmptyMessages() {
  return (
    <Empty
      title="Start messaging your team"
      body={
        <>
          Send messages and attach documents
          <br /> to communicate with your team.
        </>
      }
    />
  );
}

export function EmptyConversations() {
  return (
    <Empty
      title="No Messages yet."
      body={
        <>
          You didn't send or receive any messages yet!
          <br /> Your messages will appear here in inbox.
        </>
      }
    />
  );
}

export function Empty({
  title,
  body,
}: {
  title: string;
  body: React.ReactNode | string;
}) {
  return (
    <div className="flex flex-col flex-1 justify-center items-center ">
      <div className="mt-6 text-xl">
        <MessagesIcon className="text-gray-light w-10 h-10" />
      </div>
      <p className="text-sm font-semibold mt-4 text-gray-700">{title}</p>
      <p className=" text-sm text-center text-gray-light mt-4">{body}</p>
    </div>
  );
}
